import { TreaterDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;

export const getAllTreaters = (source: CancelTokenSource): Promise<Array<TreaterDto>> => {
  return axios
      .get(`${baseUrl}/api/treaters`, {cancelToken: source.token})
      .then(response => response.data)
};

export const getAllActiveTreaters = (source: CancelTokenSource): Promise<Array<TreaterDto>> => {
  return axios
      .get(`${baseUrl}/api/active-treaters`, {cancelToken: source.token})
      .then(response => response.data)
};

export const getAllTreatersByMandateId = (mandateId: number, source: CancelTokenSource): Promise<Array<TreaterDto>> => {
  return axios
      .get(`${baseUrl}/api/treaters-by-mandate`,{params: {mandateId: mandateId}, cancelToken: source.token})
      .then(response => response.data)
};
